// Components
import {
  MainDiv,
  SectionTitle,
  ClinicalScoreDiv,
  ClinicalScoreInfoDiv,
  SectionTitleDiv,
  StatusDiv,
  StatusText,
  StatusImg,
  OpenPopupButton,
  OpenPopupImg,
} from "./styles";
// Assets
import EditBlueIco from "../../../../../../assets/icons/btn_edit_user_blue.svg";
import EditGrayIco from "../../../../../../assets/icons/btn_edit_user_gray.svg";
import CheckIco from "../../../../../../assets/icons/check_white.svg";
import WarningIco from "../../../../../../assets/icons/ico_warning_white.svg";
import HourglassIco from "../../../../../../assets/icons/hourglass.svg";

const ClinicalScoreList = ({ clinicalScores, setCurrentClinicalScore, setShowEditClinicalScore }) => {
  const renderClinicalScore = (key) => {
    const currentClinicalScore = clinicalScores.find((clinicalScore) => clinicalScore.KEY === key);

    const mapTitle = {
      pre: "Baseline",
      END_OF_THERAPY: "End of therapy",
      FOLLOW_UP: "Follow up",
    };

    const getStatusInfo = () => {
      if (currentClinicalScore?.STATUS === "COMPLETED") {
        return {
          background: "#22B573",
          img: CheckIco,
          text: "COMPLETED",
        };
      }
      if (currentClinicalScore?.STATUS === "MISSING_DATA") {
        return {
          background: "#F15A24",
          img: WarningIco,
          text: "NOT COMPLETED",
        };
      }
      return {
        background: "#C8C8C8",
        img: HourglassIco,
        text: "WAITING",
      };
    };
    const { background, img, text } = getStatusInfo();
    const isMissingData = currentClinicalScore?.STATUS === "MISSING_DATA";
    const isWaiting = currentClinicalScore?.STATUS === "WAITING";

    const handleSetPopup = () => {
      setCurrentClinicalScore(currentClinicalScore);
      setShowEditClinicalScore(true);
    };

    return (
      <ClinicalScoreDiv>
        <ClinicalScoreInfoDiv
          border={isMissingData ? "1.5px solid #F15A24" : "none"}
          background={isMissingData ? "rgba(241, 90, 36, 0.10)" : "#f3f3f3"}
        >
          <SectionTitleDiv>
            <SectionTitle>{mapTitle[key]}</SectionTitle>
          </SectionTitleDiv>
          <StatusDiv background={background}>
            <StatusText>{text}</StatusText>
            <StatusImg src={img} alt="ico" />
          </StatusDiv>
        </ClinicalScoreInfoDiv>
        <OpenPopupButton onClick={handleSetPopup} clickable={!isWaiting}>
          <OpenPopupImg src={isWaiting ? EditGrayIco : EditBlueIco} alt="edit-ico" />
        </OpenPopupButton>
      </ClinicalScoreDiv>
    );
  };

  return (
    <MainDiv>
      <SectionTitle margin="0 0 16px 0">Clinical score list</SectionTitle>
      {renderClinicalScore("pre")}
      {renderClinicalScore("END_OF_THERAPY")}
      {renderClinicalScore("FOLLOW_UP")}
    </MainDiv>
  );
};

export default ClinicalScoreList;
